module.exports = __webpack_public_path__ + "static/media/s13.197862a7.webp";